import { useContext, useState } from "react";
import licenseBanner from "../../../_asset/banner/License_banner_2.png"
import licenseBanner_pragmatic from "../../../_asset/banner/banner_pragmatic.png"
import licenseBanner_evolution from "../../../_asset/banner/banner_evolution.png"
import LicenseBannerPopup from "../../banner/license";
import LicenseBannerPopupEvolution from "../../banner/license_evolution";
import { UserContext } from "../../../apps/_root";

export default function LicenseLayout() {
    const { UserAuthCheck } = useContext(UserContext)
    const [popShow, setPopShow] = useState<boolean>(false)
    const [popShowEvolution, setPopShowEvolution] = useState<boolean>(false)
    
    return (
        <>
        <div className="license-image col2">
            <img src={licenseBanner_pragmatic} alt="" onClick={e=> UserAuthCheck(()=> { setPopShow(true) })} />
            <img src={licenseBanner_evolution} alt="" onClick={e=> UserAuthCheck(()=> { setPopShowEvolution(true) })} />
        </div>
        
        <LicenseBannerPopup popShow={popShow} setPopShow={setPopShow} />
        <LicenseBannerPopupEvolution popShow={popShowEvolution} setPopShow={setPopShowEvolution} />
        </>
    );
}